import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { userHeader } from 'app/constants/table-header-constants';
import useUserManagement from './useUserManagement';

const UserManagement = () => {
  const {
    isdeleteFiltering,
    totalNumber,
    filteredData,
    sectionObj,
    handleDelete,
    handleEdit,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    navigate,
    fetchBillData,
  } = useUserManagement();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={userHeader}
          data={filteredData}
          fulldata={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          fetchData={fetchBillData}
          totalNumber={totalNumber}
          pageCount={pageCount}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          pageLoading={pageLoading}
          navigate={navigate}
          isdeleteFiltering={isdeleteFiltering}
        />
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default UserManagement;
